module.exports = __webpack_public_path__ + "media/images/user/lp/mv/mask_sp-d19d83e08e229ef1791f679e5384b92c.png";